import axios, { AxiosResponse } from 'axios';
import toast from 'react-hot-toast';

export interface ApiResponse<T> {
  data: T;
  error?: string;
}

const isLocalhost = window.location.hostname === 'localhost';

const BASE_URL = isLocalhost ? 'http://localhost:3455/api/v1' : 'https://stantonysmudikanam-be-production-05ba.up.railway.app/api/v1';

export const ENDPOINTS = {
  SIGN_IN: `${BASE_URL}/auth/login`,
  LIST_COLLEGES: `${BASE_URL}/admin/get-colleges`,
  DELETE_COLLEGE: `${BASE_URL}/admin/delete-college/:id`,
  UPLOAD_FILE: `${BASE_URL}/upload`,
  CREATE_COLLEGE: `${BASE_URL}/admin/create-college`,
  EDIT_COLLEGE: `${BASE_URL}/admin/update-college/:id`,
  LIST_COURSES: `${BASE_URL}/admin/get-courses`,
  CREATE_COURSE: `${BASE_URL}/admin/create-course`,
  EDIT_COURSE: `${BASE_URL}/admin/update-course/:id`,
  DELETE_COURSE: `${BASE_URL}/admin/delete-course/:id`,
  GET_COURSE: `${BASE_URL}/admin/get-course/:id`,
  LIST_UNITS: `${BASE_URL}/admin/units`,
  CREATE_UNIT: `${BASE_URL}/admin/units`,
  GET_UNIT: `${BASE_URL}/admin/units/:id`,
  UPDATE_UNIT: `${BASE_URL}/admin/units/:id`,
  DELETE_UNIT: `${BASE_URL}/admin/units/:id`,
  LIST_HERO_IMAGES: `${BASE_URL}/admin/hero-images`,
  CREATE_HERO_IMAGE: `${BASE_URL}/admin/hero-images`,
  GET_HERO_IMAGE: `${BASE_URL}/admin/hero-images/:id`,
  UPDATE_HERO_IMAGE: `${BASE_URL}/admin/hero-images/:id`,
  DELETE_HERO_IMAGE: `${BASE_URL}/admin/hero-images/:id`,
  PUBLIC_LIST_HERO_IMAGES: `${BASE_URL}/app/hero-images`,
  LIST_HISTORIES: `${BASE_URL}/admin/histories`,
  CREATE_HISTORY: `${BASE_URL}/admin/histories`,
  GET_HISTORY: `${BASE_URL}/admin/histories/:id`,
  UPDATE_HISTORY: `${BASE_URL}/admin/histories/:id`,
  DELETE_HISTORY: `${BASE_URL}/admin/histories/:id`,
  PUBLIC_LIST_HISTORIES: `${BASE_URL}/app/histories`,
  LIST_COUNCILS: `${BASE_URL}/admin/councils`,
  CREATE_COUNCIL: `${BASE_URL}/admin/councils`,
  GET_COUNCIL: `${BASE_URL}/admin/councils/:id`,
  UPDATE_COUNCIL: `${BASE_URL}/admin/councils/:id`,
  DELETE_COUNCIL: `${BASE_URL}/admin/councils/:id`,
  PUBLIC_LIST_COUNCILS: `${BASE_URL}/app/councils`,
  LIST_NEWS: `${BASE_URL}/admin/news`,
  CREATE_NEWS: `${BASE_URL}/admin/news`,
  GET_NEWS: `${BASE_URL}/admin/news/:id`,
  UPDATE_NEWS: `${BASE_URL}/admin/news/:id`,
  DELETE_NEWS: `${BASE_URL}/admin/news/:id`,
  PUBLIC_LIST_NEWS: `${BASE_URL}/app/news`,
  LIST_ABOUT: `${BASE_URL}/admin/about`,
  GET_ABOUT: `${BASE_URL}/admin/about/:id`,
  UPDATE_ABOUT: `${BASE_URL}/admin/about`,
  DELETE_ABOUT: `${BASE_URL}/admin/about`,
  PUBLIC_GET_ABOUT: `${BASE_URL}/app/about`,
  LIST_EVENTS: `${BASE_URL}/admin/events`,
  CREATE_EVENT: `${BASE_URL}/admin/events`,
  GET_EVENT: `${BASE_URL}/admin/events/:id`,
  UPDATE_EVENT: `${BASE_URL}/admin/events/:id`,
  DELETE_EVENT: `${BASE_URL}/admin/events/:id`,
  PUBLIC_LIST_EVENTS: `${BASE_URL}/app/events`,
  GET_CHURCH_INFO: `${BASE_URL}/admin/church-info`,
  UPDATE_CHURCH_INFO: `${BASE_URL}/admin/church-info`,
  PUBLIC_GET_CHURCH_INFO: `${BASE_URL}/app/church-info`,
  LIST_FAMILIES: `${BASE_URL}/admin/families`,
  CREATE_FAMILY: `${BASE_URL}/admin/families`,
  GET_FAMILY: `${BASE_URL}/admin/families/:id`,
  UPDATE_FAMILY: `${BASE_URL}/admin/families/:id`,
  DELETE_FAMILY: `${BASE_URL}/admin/families/:id`,
  LIST_FAMILY_MEMBERS: `${BASE_URL}/admin/family-members`,
  CREATE_FAMILY_MEMBER: `${BASE_URL}/admin/family-members`,
  GET_FAMILY_MEMBER: `${BASE_URL}/admin/family-members/:id`,
  UPDATE_FAMILY_MEMBER: `${BASE_URL}/admin/family-members/:id`,
  DELETE_FAMILY_MEMBER: `${BASE_URL}/admin/family-members/:id`,
  // Payment Type endpoints
  LIST_PAYMENT_TYPES: `${BASE_URL}/admin/payment-types`,
  CREATE_PAYMENT_TYPE: `${BASE_URL}/admin/payment-types`,
  GET_PAYMENT_TYPE: `${BASE_URL}/admin/payment-types/:id`,
  UPDATE_PAYMENT_TYPE: `${BASE_URL}/admin/payment-types/:id`,
  DELETE_PAYMENT_TYPE: `${BASE_URL}/admin/payment-types/:id`,
  // Payment endpoints
  LIST_PAYMENTS: `${BASE_URL}/admin/payments`,
  CREATE_PAYMENT: `${BASE_URL}/admin/payments`,
  GET_PAYMENT: `${BASE_URL}/admin/payments/:id`,
  UPDATE_PAYMENT: `${BASE_URL}/admin/payments/:id`,
  DELETE_PAYMENT: `${BASE_URL}/admin/payments/:id`,
  EXPORT_PAYMENTS: `${BASE_URL}/admin/payments/export`,
  // Payment Obligation endpoints
  LIST_PAYMENT_OBLIGATIONS: `${BASE_URL}/admin/payment-obligations`,
  CREATE_PAYMENT_OBLIGATION: `${BASE_URL}/admin/payment-obligations`,
  GENERATE_PAYMENT_OBLIGATIONS: `${BASE_URL}/admin/payment-obligations/generate`,
  GET_PAYMENT_OBLIGATION: `${BASE_URL}/admin/payment-obligations/:id`,
  UPDATE_PAYMENT_OBLIGATION: `${BASE_URL}/admin/payment-obligations/:id`,
  DELETE_PAYMENT_OBLIGATION: `${BASE_URL}/admin/payment-obligations/:id`,
  GET_OUTSTANDING_BALANCE: `${BASE_URL}/admin/payment-obligations/outstanding-balance`,
  // RBAC endpoints
  GET_MY_PERMISSIONS: `${BASE_URL}/rbac/my-permissions`,
  LIST_SUB_ADMINS: `${BASE_URL}/rbac/sub-admins`,
  CREATE_SUB_ADMIN: `${BASE_URL}/rbac/sub-admins`,
  GET_SUB_ADMIN: `${BASE_URL}/rbac/sub-admins/:id`,
  UPDATE_SUB_ADMIN_PERMISSIONS: `${BASE_URL}/rbac/sub-admins/:id/permissions`,
  DELETE_SUB_ADMIN: `${BASE_URL}/rbac/sub-admins/:id`,
};

export async function SignIn<T>(email: string, password: string): Promise<ApiResponse<T>> {
  console.log('[API] SignIn called with email:', email, 'endpoint:', ENDPOINTS.SIGN_IN);
  try {
    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.SIGN_IN, { email, password, role: 'admin' });
    console.log('[API] SignIn response received:', response.status, response.data);
    return { data: response.data };
  } catch (error: any) {
    console.error('[API] SignIn error:', error);
    console.error('[API] SignIn error response:', error.response?.data);
    console.error('[API] SignIn error message:', error.message);
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function ListColleges<T>(search: string, nextId: string | null, limit: number): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.LIST_COLLEGES, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { search, nextId, limit },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteCollege<T>(id: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_COLLEGE.replace(':id', id), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UploadFile<T>(file: File): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const formData = new FormData();
    formData.append('file', file);

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.UPLOAD_FILE, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    // Display error message from backend or default message
    const errorMessage = error.response?.data?.message || error.message || 'Failed to upload file';
    displayErrorToast({ ...error, response: { data: { message: errorMessage } } });
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

interface College {
  name: string;
  location: string;
  website: string;
  imageId: string;
}

export async function CreateCollege<T>(college: College): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_COLLEGE, college, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

function displayErrorToast(error: any) {
  const errorMessage = error.response?.data?.message || error.response?.data || error.message || 'An error occurred';
  toast.error(errorMessage, {
    duration: 3000,
    icon: '❌',
  });
}

/**
 * Helper function to check if response has error status and extract error message
 */
function checkResponseForError<T>(response: AxiosResponse<T>): { hasError: boolean; errorMessage?: string } {
  const responseData = response.data as any;
  if (responseData && responseData.status === false) {
    return {
      hasError: true,
      errorMessage: responseData.message || 'An error occurred',
    };
  }
  return { hasError: false };
}

interface EditCollegeI {
  name: string | null;
  location: string | null;
  website: string | null;
  imageId: string | null;
  _id: string;
  image: string | null;
}

export async function EditCollege<T>(college: EditCollegeI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.put(
      ENDPOINTS.EDIT_COLLEGE.replace(':id', college._id),
      {
        ...(college.name && { name: college.name }),
        ...(college.location && { location: college.location }),
        ...(college.website && { website: college.website }),
        ...(college.imageId && { imageId: college.imageId }),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function ListCourses<T>(search: string, nextId: string | null): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.LIST_COURSES, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { search, nextId },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export interface CreateCourseI {
  title: string;
  description: string;
  courseName: string;
  courseType: string;
  certification: string;
  personalities: string[];
  collageIds: string[];
}

export async function CreateCourse<T>(course: CreateCourseI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_COURSE, course, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteCourse<T>(id: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_COURSE.replace(':id', id), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export interface EditCourseI {
  _id: string;
  title: string | null;
  description: string | null;
  courseName: string | null;
  courseType: string | null;
  certification: string | null;
  personalities: string[] | null;
  collageIds: string[] | null;
}

export async function EditCourse<T>(course: EditCourseI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.put(
      ENDPOINTS.EDIT_COURSE.replace(':id', course._id),
      {
        ...(course.title && { title: course.title }),
        ...(course.description && { description: course.description }),
        ...(course.courseName && { courseName: course.courseName }),
        ...(course.courseType && { courseType: course.courseType }),
        ...(course.certification && { certification: course.certification }),
        ...(course.personalities && { personalities: course.personalities }),
        ...(course.collageIds && { collageIds: course.collageIds }),
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetCourse<T>(id: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_COURSE.replace(':id', id), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// Unit API functions
export interface CreateUnitI {
  name: string;
  unitNumber: string;
}

export interface UpdateUnitI {
  name?: string;
  unitNumber?: string;
}

export async function ListUnits<T>(search?: string, page?: number, limit?: number): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const params: any = {};
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.LIST_UNITS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateUnit<T>(unit: CreateUnitI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_UNIT, unit, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // Check if response has status: false (error response)
    const errorCheck = checkResponseForError(response);
    if (errorCheck.hasError) {
      displayErrorToast({ response: { data: { message: errorCheck.errorMessage } } });
      return { data: response.data, error: errorCheck.errorMessage };
    }

    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data?.message || error.response?.data || error.message };
  }
}

export async function GetUnit<T>(unitId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_UNIT.replace(':id', unitId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateUnit<T>(unitId: string, updateData: UpdateUnitI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_UNIT.replace(':id', unitId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // Check if response has status: false (error response)
    const errorCheck = checkResponseForError(response);
    if (errorCheck.hasError) {
      displayErrorToast({ response: { data: { message: errorCheck.errorMessage } } });
      return { data: response.data, error: errorCheck.errorMessage };
    }

    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data?.message || error.response?.data || error.message };
  }
}

export async function DeleteUnit<T>(unitId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_UNIT.replace(':id', unitId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Check if response has status: false (error response)
    const errorCheck = checkResponseForError(response);
    if (errorCheck.hasError) {
      displayErrorToast({ response: { data: { message: errorCheck.errorMessage } } });
      return { data: response.data, error: errorCheck.errorMessage };
    }

    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data?.message || error.response?.data || error.message };
  }
}

// Hero Image API functions
export interface CreateHeroImageI {
  image: string;
  order?: number;
  isActive?: boolean;
}

export interface UpdateHeroImageI {
  image?: string;
  order?: number;
  isActive?: boolean;
}

export async function ListHeroImages<T>(
  activeOnly?: boolean,
  isPublic?: boolean,
  search?: string,
  page?: number,
  limit?: number,
): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');
    const headers: any = {};

    // Only add auth header if not public request
    if (!isPublic && token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const endpoint = isPublic ? `${BASE_URL}/app/hero-images` : ENDPOINTS.LIST_HERO_IMAGES;

    const params: any = {};
    if (activeOnly) params.activeOnly = 'true';
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;

    const response: AxiosResponse<T> = await axios.get(endpoint, {
      headers,
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    if (!isPublic) {
      displayErrorToast(error);
    }
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateHeroImage<T>(heroImage: CreateHeroImageI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_HERO_IMAGE, heroImage, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetHeroImage<T>(heroImageId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_HERO_IMAGE.replace(':id', heroImageId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateHeroImage<T>(heroImageId: string, updateData: UpdateHeroImageI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_HERO_IMAGE.replace(':id', heroImageId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteHeroImage<T>(heroImageId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_HERO_IMAGE.replace(':id', heroImageId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

interface CreateHistoryI {
  period: string;
  priest: string;
  description?: string;
  image?: string;
  order?: number;
}

interface UpdateHistoryI {
  period?: string;
  priest?: string;
  description?: string;
  image?: string;
  order?: number;
}

export async function ListHistories<T>(isPublic?: boolean, search?: string, page?: number, limit?: number): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');
    const headers: any = {};

    // Only add auth header if not public request
    if (!isPublic && token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const endpoint = isPublic ? ENDPOINTS.PUBLIC_LIST_HISTORIES : ENDPOINTS.LIST_HISTORIES;

    const params: any = {};
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;

    const response: AxiosResponse<T> = await axios.get(endpoint, {
      headers,
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    if (!isPublic) {
      displayErrorToast(error);
    }
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateHistory<T>(history: CreateHistoryI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_HISTORY, history, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetHistory<T>(historyId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_HISTORY.replace(':id', historyId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateHistory<T>(historyId: string, updateData: UpdateHistoryI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_HISTORY.replace(':id', historyId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteHistory<T>(historyId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_HISTORY.replace(':id', historyId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// Council API functions
export interface CreateCouncilI {
  period: string;
  members: Array<{ member?: string; name?: string; position?: string }>;
  description?: string;
  image?: string;
}

export interface UpdateCouncilI {
  period?: string;
  members?: Array<{ member?: string; name?: string; position?: string }>;
  description?: string;
  image?: string;
}

export async function ListCouncils<T>(isPublic?: boolean, search?: string, page?: number, limit?: number): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');
    const headers: any = {};

    // Only add auth header if not public request
    if (!isPublic && token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const endpoint = isPublic ? ENDPOINTS.PUBLIC_LIST_COUNCILS : ENDPOINTS.LIST_COUNCILS;

    const params: any = {};
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;

    const response: AxiosResponse<T> = await axios.get(endpoint, {
      headers,
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    if (!isPublic) {
      displayErrorToast(error);
    }
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateCouncil<T>(council: CreateCouncilI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_COUNCIL, council, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetCouncil<T>(councilId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_COUNCIL.replace(':id', councilId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateCouncil<T>(councilId: string, updateData: UpdateCouncilI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_COUNCIL.replace(':id', councilId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteCouncil<T>(councilId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_COUNCIL.replace(':id', councilId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// News API functions
export interface CreateNewsI {
  title: string;
  description: string;
  fullContent: string;
  image?: string;
  date: string;
}

export interface UpdateNewsI {
  title?: string;
  description?: string;
  fullContent?: string;
  image?: string;
  date?: string;
}

export async function ListNews<T>(isPublic?: boolean, search?: string, page?: number, limit?: number): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');
    const headers: any = {};

    // Only add auth header if not public request
    if (!isPublic && token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const endpoint = isPublic ? ENDPOINTS.PUBLIC_LIST_NEWS : ENDPOINTS.LIST_NEWS;

    const params: any = {};
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;

    const response: AxiosResponse<T> = await axios.get(endpoint, {
      headers,
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    if (!isPublic) {
      displayErrorToast(error);
    }
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateNews<T>(news: CreateNewsI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_NEWS, news, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetNews<T>(newsId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_NEWS.replace(':id', newsId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateNews<T>(newsId: string, updateData: UpdateNewsI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_NEWS.replace(':id', newsId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteNews<T>(newsId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_NEWS.replace(':id', newsId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// About API functions
export interface CreateAboutI {
  title?: string;
  content: string;
  image?: string;
}

export interface UpdateAboutI {
  title?: string;
  content?: string;
  image?: string;
}

export async function GetAbout<T>(isPublic?: boolean): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');
    const headers: any = {};

    // Only add auth header if not public request
    if (!isPublic && token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const endpoint = isPublic ? ENDPOINTS.PUBLIC_GET_ABOUT : ENDPOINTS.LIST_ABOUT;

    const response: AxiosResponse<T> = await axios.get(endpoint, {
      headers,
    });
    return { data: response.data };
  } catch (error: any) {
    if (!isPublic) {
      displayErrorToast(error);
    }
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateAbout<T>(about: CreateAboutI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.LIST_ABOUT, about, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateAbout<T>(updateData: UpdateAboutI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_ABOUT, updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteAbout<T>(): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_ABOUT, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// Events API functions
export interface CreateEventI {
  title: string;
  date: string;
  time: string;
  location: string;
  type: 'service' | 'special' | 'community';
  image?: string;
  description?: string;
}

export interface UpdateEventI {
  title?: string;
  date?: string;
  time?: string;
  location?: string;
  type?: 'service' | 'special' | 'community';
  image?: string;
  description?: string;
}

export async function ListEvents<T>(isPublic?: boolean, search?: string, page?: number, limit?: number): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');
    const headers: any = {};

    // Only add auth header if not public request
    if (!isPublic && token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const endpoint = isPublic ? ENDPOINTS.PUBLIC_LIST_EVENTS : ENDPOINTS.LIST_EVENTS;

    const params: any = {};
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;

    const response: AxiosResponse<T> = await axios.get(endpoint, {
      headers,
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    if (!isPublic) {
      displayErrorToast(error);
    }
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateEvent<T>(event: CreateEventI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_EVENT, event, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetEvent<T>(eventId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_EVENT.replace(':id', eventId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateEvent<T>(eventId: string, updateData: UpdateEventI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_EVENT.replace(':id', eventId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteEvent<T>(eventId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_EVENT.replace(':id', eventId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// Family API functions
export interface CreateFamilyI {
  familyName: string;
  unit: string;
  guardian?: CreateFamilyMemberI;
  members?: CreateFamilyMemberI[];
}

export interface UpdateFamilyI {
  familyName?: string;
  unit?: string;
  guardian?: string;
}

export interface CreateFamilyMemberI {
  name: string;
  dob?: string;
  education?: string;
  job?: string;
  baptismDate?: string;
  firstCommunionDate?: string;
  confirmationDate?: string;
  married?: boolean;
  marriedDate?: string;
  deathDate?: string;
  contactNumbers?: string[];
  family?: string;
}

export interface UpdateFamilyMemberI {
  name?: string;
  dob?: string;
  education?: string;
  job?: string;
  baptismDate?: string;
  firstCommunionDate?: string;
  confirmationDate?: string;
  married?: boolean;
  marriedDate?: string;
  deathDate?: string;
  contactNumbers?: string[];
  family?: string;
}

export async function ListFamilies<T>(search?: string, page?: number, limit?: number): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const params: any = {};
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.LIST_FAMILIES, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateFamily<T>(family: CreateFamilyI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_FAMILY, family, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetFamily<T>(familyId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_FAMILY.replace(':id', familyId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateFamily<T>(familyId: string, updateData: UpdateFamilyI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_FAMILY.replace(':id', familyId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteFamily<T>(familyId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_FAMILY.replace(':id', familyId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// Family Member API functions
export async function ListFamilyMembers<T>(familyId?: string, search?: string, page?: number, limit?: number): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const params: any = {};
    if (familyId) params.familyId = familyId;
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.LIST_FAMILY_MEMBERS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateFamilyMember<T>(member: CreateFamilyMemberI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_FAMILY_MEMBER, member, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetFamilyMember<T>(memberId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_FAMILY_MEMBER.replace(':id', memberId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateFamilyMember<T>(memberId: string, updateData: UpdateFamilyMemberI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_FAMILY_MEMBER.replace(':id', memberId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteFamilyMember<T>(memberId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_FAMILY_MEMBER.replace(':id', memberId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// RBAC API functions
export interface Permission {
  resource: string;
  actions: string[];
}

export interface SubAdmin {
  _id: string;
  email: string;
  name: string;
  firstName?: string;
  lastName?: string;
  role: string;
  permissions?: Permission[];
  createdBy?: {
    _id: string;
    email: string;
    name: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateSubAdminI {
  email: string;
  password: string;
  name?: string;
  firstName?: string;
  lastName?: string;
}

export interface UpdatePermissionsI {
  permissions: Permission[];
}

export async function GetMyPermissions<T>(): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_MY_PERMISSIONS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function ListSubAdmins<T>(): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.LIST_SUB_ADMINS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreateSubAdmin<T>(subAdmin: CreateSubAdminI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_SUB_ADMIN, subAdmin, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetSubAdmin<T>(subAdminId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_SUB_ADMIN.replace(':id', subAdminId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateSubAdminPermissions<T>(subAdminId: string, permissions: UpdatePermissionsI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_SUB_ADMIN_PERMISSIONS.replace(':id', subAdminId), permissions, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeleteSubAdmin<T>(subAdminId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_SUB_ADMIN.replace(':id', subAdminId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// Church Info API functions
export interface ServiceTime {
  day: string;
  time: string;
  description?: string;
}

export interface SocialLink {
  platform: 'Facebook' | 'Instagram' | 'Twitter' | 'YouTube' | 'LinkedIn' | 'WhatsApp' | 'Other';
  url: string;
}

export interface ChurchInfo {
  _id?: string;
  address: string;
  phone: string;
  email: string;
  serviceTimes: ServiceTime[];
  socialLinks?: SocialLink[];
}

export interface UpdateChurchInfoI {
  address?: string;
  phone?: string;
  email?: string;
  serviceTimes?: ServiceTime[];
  socialLinks?: SocialLink[];
}

export async function GetChurchInfo<T>(isPublic?: boolean): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');
    const headers: any = {};

    // Only add auth header if not public request
    if (!isPublic && token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const endpoint = isPublic ? ENDPOINTS.PUBLIC_GET_CHURCH_INFO : ENDPOINTS.GET_CHURCH_INFO;

    const response: AxiosResponse<T> = await axios.get(endpoint, {
      headers,
    });
    return { data: response.data };
  } catch (error: any) {
    if (!isPublic) {
      displayErrorToast(error);
    }
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdateChurchInfo<T>(updateData: UpdateChurchInfoI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_CHURCH_INFO, updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// Payment Type API functions
export interface PaymentType {
  _id: string;
  name: string;
  category: 'subscription' | 'event' | 'donation';
  frequency: 'monthly' | 'yearly' | 'oneTime';
  amount: number;
  currency: string;
  isActive: boolean;
  startDate?: string | null;
  endDate?: string | null;
  totalCollected?: number;
  paymentCount?: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePaymentTypeI {
  name: string;
  category: 'subscription' | 'event' | 'donation';
  frequency: 'monthly' | 'yearly' | 'oneTime';
  amount: number;
  currency?: string;
  startDate?: string | null;
  endDate?: string | null;
}

export interface UpdatePaymentTypeI {
  name?: string;
  category?: 'subscription' | 'event' | 'donation';
  frequency?: 'monthly' | 'yearly' | 'oneTime';
  isActive?: boolean;
  startDate?: string | null;
  endDate?: string | null;
}

export async function ListPaymentTypes<T>(search?: string, page?: number, limit?: number, isActive?: boolean): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const params: any = {};
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (isActive !== undefined) params.isActive = isActive;

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.LIST_PAYMENT_TYPES, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreatePaymentType<T>(paymentType: CreatePaymentTypeI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_PAYMENT_TYPE, paymentType, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetPaymentType<T>(paymentTypeId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_PAYMENT_TYPE.replace(':id', paymentTypeId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdatePaymentType<T>(paymentTypeId: string, updateData: UpdatePaymentTypeI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_PAYMENT_TYPE.replace(':id', paymentTypeId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeletePaymentType<T>(paymentTypeId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_PAYMENT_TYPE.replace(':id', paymentTypeId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// Payment API functions
export interface PaymentAllocation {
  paymentObligationId:
    | {
        _id: string;
        period: string;
        amountDue: number;
        amountPaid: number;
      }
    | string;
  amountApplied: number;
}

export interface Payment {
  _id: string;
  paymentTypeId: PaymentType | string;
  familyId:
    | {
        _id: string;
        familyName: string;
      }
    | string;
  memberId?:
    | {
        _id: string;
        name: string;
      }
    | string
    | null;
  totalAmountPaid: number;
  paymentAllocations?: PaymentAllocation[];
  paymentMethod: 'cash' | 'upi' | 'card' | 'bankTransfer';
  transactionId?: string | null;
  status: 'pending' | 'success' | 'failed';
  paidAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePaymentI {
  paymentTypeId: string;
  familyId: string;
  memberId?: string | null;
  totalAmountPaid: number;
  paymentAllocations?: Array<{
    paymentObligationId: string;
    amountApplied: number;
  }>;
  paymentMethod: 'cash' | 'upi' | 'card' | 'bankTransfer';
  transactionId?: string | null;
  paidAt?: string;
}

export interface UpdatePaymentI {
  familyId?: string;
  memberId?: string | null;
  totalAmountPaid?: number;
  paymentAllocations?: Array<{
    paymentObligationId: string;
    amountApplied: number;
  }>;
  paymentMethod?: 'cash' | 'upi' | 'card' | 'bankTransfer';
  transactionId?: string | null;
  status?: 'pending' | 'success' | 'failed';
  paidAt?: string;
}

export async function ListPayments<T>(
  search?: string,
  page?: number,
  limit?: number,
  paymentTypeId?: string,
  familyId?: string,
  memberId?: string,
  status?: string,
  startDate?: string,
  endDate?: string,
): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const params: any = {};
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (paymentTypeId) params.paymentTypeId = paymentTypeId;
    if (familyId) params.familyId = familyId;
    if (memberId) params.memberId = memberId;
    if (status) params.status = status;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.LIST_PAYMENTS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreatePayment<T>(payment: CreatePaymentI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_PAYMENT, payment, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetPayment<T>(paymentId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_PAYMENT.replace(':id', paymentId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdatePayment<T>(paymentId: string, updateData: UpdatePaymentI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_PAYMENT.replace(':id', paymentId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeletePayment<T>(paymentId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_PAYMENT.replace(':id', paymentId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function ExportPayments<T>(
  paymentTypeId?: string,
  familyId?: string,
  memberId?: string,
  status?: string,
  startDate?: string,
  endDate?: string,
): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const params: any = {};
    if (paymentTypeId) params.paymentTypeId = paymentTypeId;
    if (familyId) params.familyId = familyId;
    if (memberId) params.memberId = memberId;
    if (status) params.status = status;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.EXPORT_PAYMENTS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

// Payment Obligation API functions
export interface PaymentObligation {
  _id: string;
  paymentTypeId: PaymentType | string;
  familyId:
    | {
        _id: string;
        familyName: string;
      }
    | string;
  period: string; // Format: "YYYY-MM" for monthly, "YYYY" for yearly
  amountDue: number;
  amountPaid: number;
  status: 'pending' | 'partial' | 'paid';
  dueDate: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePaymentObligationI {
  paymentTypeId: string;
  familyId: string;
  period: string;
  dueDate?: string;
}

export interface GenerateObligationsI {
  paymentTypeId: string;
  familyId: string;
  startPeriod: string;
  endPeriod: string;
}

export interface UpdatePaymentObligationI {
  dueDate?: string;
}

export async function ListPaymentObligations<T>(
  search?: string,
  page?: number,
  limit?: number,
  paymentTypeId?: string,
  familyId?: string,
  status?: string,
  period?: string,
  startPeriod?: string,
  endPeriod?: string,
): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const params: any = {};
    if (search && search.trim() !== '') params.search = search.trim();
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (paymentTypeId) params.paymentTypeId = paymentTypeId;
    if (familyId) params.familyId = familyId;
    if (status) params.status = status;
    if (period) params.period = period;
    if (startPeriod) params.startPeriod = startPeriod;
    if (endPeriod) params.endPeriod = endPeriod;

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.LIST_PAYMENT_OBLIGATIONS, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function CreatePaymentObligation<T>(obligation: CreatePaymentObligationI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.CREATE_PAYMENT_OBLIGATION, obligation, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GeneratePaymentObligations<T>(data: GenerateObligationsI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.post(ENDPOINTS.GENERATE_PAYMENT_OBLIGATIONS, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetPaymentObligation<T>(obligationId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_PAYMENT_OBLIGATION.replace(':id', obligationId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function UpdatePaymentObligation<T>(obligationId: string, updateData: UpdatePaymentObligationI): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.patch(ENDPOINTS.UPDATE_PAYMENT_OBLIGATION.replace(':id', obligationId), updateData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function DeletePaymentObligation<T>(obligationId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.delete(ENDPOINTS.DELETE_PAYMENT_OBLIGATION.replace(':id', obligationId), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}

export async function GetOutstandingBalance<T>(familyId: string, paymentTypeId: string): Promise<ApiResponse<T>> {
  try {
    const token = localStorage.getItem('token');

    const response: AxiosResponse<T> = await axios.get(ENDPOINTS.GET_OUTSTANDING_BALANCE, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { familyId, paymentTypeId },
    });
    return { data: response.data };
  } catch (error: any) {
    displayErrorToast(error);
    return { data: {} as T, error: error.response?.data || error.message };
  }
}
